import { createReducer } from '@reduxjs/toolkit'

import { campaignChangelogTableColumnsConfig } from 'configuration/tables/changelogTable'
import { DATES, AUTOMATIONS, RESOURCE_TYPES } from 'const/filters'
import { FILTER_SETTINGS, LOCAL_FILTERS } from 'const/reducerKeys'
import { serializeColumns } from 'helpers/tables'
import { defaultTab, getDefaultTable } from 'reducers/ui/defaults'

const initialState = {
    ...defaultTab,
    [LOCAL_FILTERS]: {
        [AUTOMATIONS]: [],
        [RESOURCE_TYPES]: [],
        [DATES]: 'yesterday',
    },
    [FILTER_SETTINGS]: {
        anchored: [DATES],
        order: [AUTOMATIONS, RESOURCE_TYPES],
        displayState: {
            [AUTOMATIONS]: true,
            [RESOURCE_TYPES]: true,
        },
    },
    table: getDefaultTable(
        serializeColumns(campaignChangelogTableColumnsConfig),
        {
            sorter: {
                field: ['date'],
                order: 'descend',
            },
        }
    ),
}

export default createReducer(initialState, () => {})
